import Backbone from "backbone";
import Form from './auth/FormValidator';

export default Backbone.View.extend({
    selectors: {
      form: ".js-bank-form"
    },
    initialize: function () {
      this.validator = new Form({ target: this.selectors.form });
    }
  });
